import React, { useState, useEffect } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import RenderizarProduto from "../Utils/RenderizarProduto";
import AOS from "aos";
import 'aos/dist/aos.css';
import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useParams, useNavigate} from 'react-router-dom';



const SelecionarCliente = ({ venda, setVenda}) => {
    const [avancada, setAvancada] = useState(false);
    const { 
      crud,
      salvarDados,
      buscarDados,
      buscarDadosPorId,
      setLinks, 
      setBtns,
      setTitle,
      setTour,
      hasPerms,
    } = useProvider();
    const { get, loading } = crud || {};
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const [filtroCliente, setFiltroCliente] = useState("todos");
    const [clientes, setClientes] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    
    setTitle('Selecionar Cliente');
    
    useEffect(() => {
        const tour = {
          id:"ckSelectCliente",
          lista:[
            {
              id: "#gvendas",
              titulo: `Inciniar nova venda`,
              descricao: `Aqui nessa tela você vai informar um cliente para iniciar a venda`,
              prev: false,
              next: true,
              finish: false
            },
            {
              id: "#btnCkPesquisarCliente",
              titulo: "Pesquisar Cliente",
              descricao: "Aqui você pode digitar a pesquisa por um cliente que deseja para iniciar a venda.",
              prev: true,
              next: true,
              finish: false
            },
            {
              id: "#listaCkClientes",
              titulo: "Lista de clientes",
              descricao: "Aqui vai aparecer o resultado da pesquisa, selecione um cliente para prossequir.",
              prev: true,
              next: true,
              finish: false
            },
            {
              id: "#btnCkAddCliente",
              titulo: "Adicionar Novo Cliente",
              descricao: "Aqui você pode cadastrar um novo cliente caso ainda não tenha ele cadastrado.",
              prev: true,
              next: false,
              finish: true
            },
          ]
        }
        setLinks([
          // { name: 'Nova Venda', to: '/vendas/novo' },
          // { name: 'Novo Produto', to: '/produtos/novo' },
          // { name: 'Novo Cliente', to: '/clientes/novo' },
          //{ name: 'Configurações', to: '/configuracoes' },
        ]);
        setBtns([
          //{icon:'bi-arrow-repeat', to:`/painel/sync`, id:"btnSync"},
        ]);
        setTour(tour);
        return () => {setLinks([]); setBtns([]); setTour({});}
    }, [setLinks, setBtns, setTour]);
  

    // useEffect(() => {
    //     // Inicialize o AOS para as animações, caso esteja usando isso
    //     AOS.init({
    //       duration: 1000,
    //       easing: "ease-in-out",
    //       once: true,
    //       mirror: false,
    //     });
    // }, []);
    
    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarClientes();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    
    function filtroAvancadoCliente(item, query, filtroCliente, avancada = false) {
      const data = new Date();
      const dataItem = new Date();
      const dataLimite = new Date();
      let formatada = data.toLocaleDateString('sv-SE');
      const queryLower = query?.toLowerCase();
      let funcAvancada = true;
    
      const searchValido = queryLower
        ? item.nome_do_cliente?.toLowerCase().includes(queryLower)
        : true;
        
    
      switch (filtroCliente) {
        case "todos":
          funcAvancada = queryLower? true : parseInt(item.numero_de_compras||0) > 0;
          break;
    
        case "top10Compradores":
          funcAvancada = item.ativo &&
                         !item.is_inadimplente &&
                         parseInt(item.numero_de_compras||0) > 0;
          break;
    
        case "semCompra":
          funcAvancada = item.ativo &&
                         parseInt(item.numero_de_compras||0) === 0;
          break;
    
        case "comCompra":
          funcAvancada = !item.is_inadimplente &&
                         parseInt(item.numero_de_compras||0) > 0;
          break;
    
        case "semDebito":
          funcAvancada = parseInt(item.numero_de_compras||0) > 0 &&
                         parseFloat(item.total_aberto||0) === 0;
          break;
    
        case "comDebito":
          funcAvancada = parseInt(item.numero_de_compras||0) > 0 &&
                         parseFloat(item.total_aberto||0) > 0;
          break;
    
        case "mais30":
          data.setDate(data.getDate() - 30);
          dataItem = new Date(item.data_ultima_compra).getTime();
          //const hoje = new Date().toLocaleDateString('sv-SE');
          dataLimite = new Date(data).getTime();
          funcAvancada = item.ativo &&
                         parseInt(item.numero_de_compras||0) > 0 &&
                         parseFloat(item.total_aberto||0) === 0 &&
                         dataItem <= dataLimite;
          break;
    
        case "mais60":
          data.setDate(data.getDate() - 60);
          dataItem = new Date(item.data_ultima_compra).getTime();
          //const hoje = new Date().toLocaleDateString('sv-SE');
          dataLimite = new Date(data).getTime();
          funcAvancada = item.ativo &&
                         parseInt(item.numero_de_compras||0) > 0 &&
                         parseFloat(item.total_aberto||0) === 0 &&
                         dataItem <= dataLimite;
          break;
    
        case "mais90":
          data.setDate(data.getDate() - 90);
          dataItem = new Date(item.data_ultima_compra).getTime();
          //const hoje = new Date().toLocaleDateString('sv-SE');
          dataLimite = new Date(data).getTime();
          funcAvancada = item.ativo &&
                         parseInt(item.numero_de_compras||0) > 0 &&
                         parseFloat(item.total_aberto||0) === 0 &&
                         dataItem <= dataLimite;
          break;
    
        case "inativo":
          funcAvancada = !item.ativo //&&
                         //parseInt(item.numero_de_compras||0) === 0;
          break;
    
        case "inadimplentes":
          funcAvancada = item.is_inadimplente;
          break;
    
        default:
          funcAvancada = true;
          break;
      }
    
      return searchValido && funcAvancada;
    }
    

    const carregarLocal = async()=>{
      try{
        let response;
        if(query || filtroCliente) {
          response = await buscarDados(
            'db_clientes',  
            item => filtroAvancadoCliente(item, query, filtroCliente, avancada),
            filtroCliente==="top10Compradores"?10:10,
            filtroCliente==="top10Compradores"?"total_em_pagamentos":"nome_do_cliente",
            filtroCliente==="top10Compradores"?"desc":"asc",
          );
        }else{
          response = await buscarDados(
            'db_clientes',
            null,
            filtroCliente==="top10Compradores"?10:10,
            filtroCliente==="top10Compradores"?"total_em_pagamentos":"nome_do_cliente",
            filtroCliente==="top10Compradores"?"desc":"asc",
          );
        }
        if (response && response.length) {
          const base = response;
          setClientes(base);
        }
      }catch(err){

      } finally {
        buscarClientes(true);
        // setTimeout(() => {
        // }, 1000); // espera em ms antes de buscar online
      }
    }
    

    const selecionarCliente = async(x)=>{
      try{
        const response = await buscarDadosPorId('local_registros', 'checkout');
        const item = { 
            ...response,
            venda: {
              ...response?.venda,
              cliente: x,
            },
        }
        await salvarDados('local_registros', {
          ...item,
          id:"checkout"
        });
        
        setVenda(item?.venda)
        //setVenda((prevVenda) => ({ ...prevVenda, cliente: x }));
      }catch(err){
        
      }finally{
        navigate("/checkout/adicionar-produtos", { replace: true });
      }
    }
    

    const buscarClientes = async (novaBusca = false) => {
            let url = "/gvendas/clientes/?filtros=full_name,nome,nome_do_cliente,is_conta_externa,tempo_ultima_compra,numero_de_compras,total_em_pagamentos,total_aberto,is_cliente,foto_perfil,id,endereco,posicao_mapa,foto_mapa,score,observacoes";
            let data = new Date();
            switch(filtroCliente){
              case 'mais30':
                data.setDate(data.getDate()-30).toLocaleDateString('sv-SE');
                break
              case 'mais60':
                data.setDate(data.getDate()-60).toLocaleDateString('sv-SE');
                break
              case 'mais90':
                data.setDate(data.getDate()-90).toLocaleDateString('sv-SE');
                break
            }
            if (query) url += `&search=${query}`;
            if (!query) url += `&ordering=nome_do_cliente`;
            if (filtroCliente === "todos") url += "&ativo=true";
            else if (filtroCliente === "comCompra") url += "&ativo=true&numero_de_compras__gt=0";
            else if (filtroCliente === "semCompra") url += "&ativo=true&numero_de_compras=0";
            else if (filtroCliente === "comDebito") url += "&ativo=true&numero_de_compras__gt=0&total_aberto__gt=0";
            else if (filtroCliente === "semDebito") url += "&ativo=true&numero_de_compras__gt=0&total_aberto=0";
            else if (filtroCliente === "mais30") url += `&ativo=true&numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data}`;
            else if (filtroCliente === "mais60") url += `&ativo=true&numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data}`;
            else if (filtroCliente === "mais90") url += `&ativo=true&numero_de_compras__gt=0&total_aberto=0&data_ultima_compra__lt=${data}`;

            if (novaBusca) {
                //setClientes([]);
                setNextUrl(null);
            } else if (nextUrl) {
                url = nextUrl;
            } else {
                return;
            }

            try {
                const response = await get(url, "checkout");
                if (response && response.length) {
                    const novosItens = response[0].results;
                    setClientes((clientesAnteriores) =>
                        novaBusca ? novosItens : [...clientesAnteriores, ...novosItens]
                    );
                    setNextUrl(response[0].next);
                    //await salvarDados('db_clientes', novosItens);
                }
            } catch (err) {
                console.error("Erro ao buscar clientes", err);
            }
    };

    const handleQueryChange = (e) => {
        setQuery(e.target.value);
    };

    useEffect(() => {
        //buscarClientes(true);
        carregarLocal()
    }, [query, filtroCliente]);

    return (
        <div className="my-3">
            <div>
                <Form.Group controlId="formBasicSearch">
                    <div className="input-group">
                        <Button id="btnCkAddCliente" variant="secondary" onClick={() => navigate("/contatos/novo/cliente?is_venda=true")}>
                            <i className="bi bi-person-fill-add"></i> Cliente
                        </Button>
                        <Form.Control
                            type="text"
                            id="btnCkPesquisarCliente"
                            placeholder="Digite sua pesquisa"
                            value={query}
                            onChange={handleQueryChange}
                        />
                        <Button variant="secondary" onClick={() => buscarClientes(true)}>
                            <i className="bi bi-search"></i>
                        </Button>
                    </div>
                </Form.Group>
            </div>

            <div id="listaCkClientes" className="list-group mt-3">
                {clientes.length > 0 ? (
                    clientes.map((x,index) => (
                      <div>
                        <RenderizarProduto
                            key={x.id}
                            onClick={() => selecionarCliente(x)}
                            bcolor={x.is_conta_externa?'red':''}
                            lm="mb-1"
                            src={x.foto_perfil}
                            titulo={x.full_name||x.nome_do_cliente}
                            text1={`${x.numero_de_compras > 0 ? x.numero_de_compras + " compra" + (x.numero_de_compras > 1 ? "s, última" : ",") + " a " + x.tempo_ultima_compra : ""}`}
                            text2={(<>
                              {`${x.is_cliente ? parseFloat(x.total_em_pagamentos||0).toLocaleString("pt-br", { style: "currency", currency: "BRL" }) + " pago" : ""} ${parseFloat(x.total_aberto||0) > 0 ? " e " + parseFloat(x.total_aberto||0).toLocaleString("pt-br", { style: "currency", currency: "BRL" }) + " em aberto" : ""}`}
                              {x.is_conta_externa?(<div>
                                Obs: débito com outro consultor
                              </div>):''}
                              <div>score {x.score}/1000</div>
                            </>)}
                        />
                      </div>
                    ))
                ) : (
                      !(loading) && <p data-aos="fade-up" className="text-center text-muted">Nenhum cliente encontrado.</p>
                )}
                {(loading) && <p  className="text-center"><Spinner animation="border" /></p>}
                {nextUrl && !(loading) && (
                    <Button variant="secondary" onClick={() => buscarClientes(false)} className="mt-2">
                        Buscar mais...
                    </Button>
                )}
            </div>
        </div>
    );
};

export default SelecionarCliente;